var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-page',{attrs:{"page-title":"Cost Centres","page-icon":"mdi-chart-pie","collection-name":"costCentre","items-per-page":20,"add-dialog-title":"Add Cost Centre","is-filter":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }